
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-dark-950 text-white border-t border-dark-800">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo and Company Info */}
          <div className="space-y-4">
            <img 
              src="https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/bcdcde40e3d45c7721e4a634ef58f84e.png"
              alt="Greater Golden Horseshoe Mortgages"
              className="h-16 w-auto object-contain mb-4"
            />
            <div className="text-sm text-gray-400">
              <div className="font-semibold text-white mb-2">Licensed Mortgage Agent</div>
              <div>License # 13121</div>
              <div className="mt-4">
                Helping families across the Greater Golden Horseshoe achieve their homeownership dreams.
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link to="/" className="hover:text-red-400 transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-red-400 transition-colors duration-200">
                  About Me
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-red-400 transition-colors duration-200">
                  Contact
                </Link>
              </li>
              <li>
                <a href="#services" className="hover:text-red-400 transition-colors duration-200">
                  Services
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Information */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Get In Touch</h3>
            <div className="space-y-3 text-gray-400">
              <div className="flex items-center">
                <i className="ri-phone-line mr-3 text-red-400"></i>
                <a href="tel:5196583026" className="hover:text-red-400 transition-colors duration-200">
                  (519) 658-3026
                </a>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line mr-3 text-red-400"></i>
                <a href="mailto:tmonteiro@mortgagealliance.com" className="hover:text-red-400 transition-colors duration-200">
                  tmonteiro@mortgagealliance.com
                </a>
              </div>
              <div className="flex items-start">
                <i className="ri-map-pin-line mr-3 text-red-400 mt-1"></i>
                <div>
                  Serving the Greater Golden Horseshoe<br />
                  Ontario, Canada
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-dark-800 mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">
            <div>
              © 2025 Greater Golden Horseshoe Mortgages. All rights reserved. | <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-red-400 transition-colors duration-200">Pockitt</a>
            </div>
            <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-6 mt-4 md:mt-0">
              <div className="flex space-x-6">
                <a href="https://www.mortgagealliance.com/en/TonyMonteiro/privacy-policy/" target="_blank" rel="noopener noreferrer" className="hover:text-red-400 transition-colors duration-200">
                  Privacy Policy
                </a>
                <a href="#terms" className="hover:text-red-400 transition-colors duration-200">
                  Terms of Service
                </a>
              </div>
              {/* Pockitt Branding */}
              <div className="bg-dark-800 border border-red-600/30 rounded-xl px-6 py-4 text-center md:text-left">
                <div className="text-white font-semibold text-xl">
                  Website by <a 
                    href="https://pockitt.info/" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="font-bold text-red-400 hover:text-red-300 transition-colors duration-200 text-2xl"
                  >
                    Pockitt
                  </a>
                </div>
                <div className="text-gray-400 text-sm mt-1">Design • Development • Hosting</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
}
